import { observer } from '@formily/reactive-vue';
import { connect, mapProps, mapReadPretty, h, useField, useFieldSchema } from '@formily/vue';
import { ref, defineComponent, computed, watch } from '@vue/composition-api';
import {
  Picker as VanPicker,
  Search as VanSearch,
  Popup as VanPopup,
  CheckboxGroup as VanCheckboxGroup,
  Checkbox as VanCheckbox,
  Toast,
} from 'vant';
import { formilyFormItem } from './index';
import { PreviewText } from '@formily/vant';
import store from '@/store';
import { postHunyuan } from '@/api/commonApi.js';
// @ts-ignore
import VoiceInput from './VoiceInput.vue';
// @ts-ignore
import ImageUploadInput from './ImageUploadInput.vue';

// 自定义 Picker 预览组件，添加特定类名用于样式定制
const PickerPreviewText = {
  // 声明这是一个 函数式组件
  functional: true,
  render(h, context) {
    return h(PreviewText.Picker, {
      ...context.data,
      class: [context.data.class, 'picker-preview-text'],
    }, context.children);
  },
};

const BasePicker = observer(
  defineComponent({
    name: 'FBasePicker',
    props: ['options'],
    setup(props, { attrs, emit, slots }) {
      const field = useField();
  const schema = useFieldSchema().value;

      const {
        formItemProps = {},
        popupProps = {},
        pickerProps = {},
        fieldListeners = {},
        popupListeners = {},
        pickerListeners = {},
      } = attrs;
      const show = ref(false);
      const filtered = ref([]);
      const searchValue = ref('');
      const inputValue = ref('');
      const selected = ref(attrs.value || []);
      const showFiltered = computed(
        () => !!searchValue.value && field.value.componentProps.filterable
      );
      const dataSource = computed(() =>
        props.options ? props.options.map(({ label, value, disabled }) => ({ label, value, disabled })) : []
      );
      
      // 语音输入相关状态
      const isProcessingVoice = ref(false);
      const voiceRecognitionText = ref(''); // 存储正在识别的文本
      let voiceVisible = false;
      let lastVoiceInputTime = 0; // 记录上次语音输入时间
      const DEBOUNCE_DELAY = 1000; // 防抖延迟时间（毫秒）
      
      try {
        const users = JSON.parse(store.getters.getConfigItem('cpnShowVoice'));
        if (users?.includes?.(sessionStorage.getItem('userid'))) {
          voiceVisible = true;
        }
        if (users?.length === 0) {
          voiceVisible = true
        }
      } catch (e) {
        // 配置解析失败，不显示语音输入
      }
      
      // 处理语音输入
      const handleVoiceInput = async (query) => {
        const sessionId = `picker_voice_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const startTime = Date.now();
        
        if (!query || !query.trim()) {
          Toast('语音输入内容为空');
          voiceRecognitionText.value = '';
          
          // 上报：空输入
          try {
            const aegis = store.state.user?.aegis;
            if (aegis) {
              aegis.infoAll({
                msg: JSON.stringify({
                  type: 'picker_voice_input_empty',
                  component: 'Picker',
                  sessionId: sessionId,
                  fieldName: field.value.path?.toString() || '',
                  fieldTitle: field.value.title || '',
                  timestamp: new Date().toISOString(),
                }),
                ext1: 'picker-voice-input',
                trace: 'picker-voice-empty',
              });
            }
          } catch (e) {
            console.error('[Picker] Aegis 上报失败:', e);
          }
          
          return;
        }
        
        voiceRecognitionText.value = `AI正在处理: ${query}`;
        isProcessingVoice.value = true;
        
        let apiResult = null;
        let isSuccess = false;
        let errorInfo = null;
        let finalValue = null;
        
        // 上报：开始 AI 处理
        try {
          const aegis = store.state.user?.aegis;
          if (aegis) {
            aegis.infoAll({
              msg: JSON.stringify({
                type: 'picker_voice_ai_start',
                component: 'Picker',
                sessionId: sessionId,
                fieldName: field.value.path?.toString() || '',
                fieldTitle: field.value.title || '',
                query: query,
                queryLength: query.length,
                optionsCount: dataSource.value?.length || 0,
                isMultiple: !!field.value.componentProps.multiple,
                timestamp: new Date().toISOString(),
              }),
              ext1: 'picker-voice-ai',
              trace: 'picker-ai-start',
            });
          }
        } catch (e) {
          console.error('[Picker] Aegis 上报失败:', e);
        }
        
        try {
          // 创建对话参数
          const createConversationParams = () => {
            console.log(field.value, 'field.value')
            return {
              context: JSON.stringify({
                schema: JSON.stringify(schema),
                flowdata: JSON.stringify(dataSource.value)
              }),
            };
          };
          
          const conversationParams = createConversationParams();
          
          // 调用AI接口
          const result = await postHunyuan(
            query,
            'hyaide-application-' + (store.getters.getConfigItem('hunyuanServiceId') || '20904'),
            conversationParams
          );
          
          apiResult = result;
          
          // 解析AI返回的结果
          if (result?.data?.data?.result) {
            const parsedResult = JSON.parse(result.data.data.result);
            console.log(parsedResult, 'parsedResult')
            // 根据解析结果设置值
            if (((typeof parsedResult?.data) === 'number') || ((typeof parsedResult?.data) === 'string') || Array.isArray(parsedResult?.data)) {
              console.log(parsedResult?.data, dataSource.value, dataSource.value.some((item) => item.value === parsedResult.data))
              if (!field.value.componentProps.multiple && (typeof parsedResult.data === 'string' || (typeof parsedResult?.data) === 'number')) {
                const res = dataSource.value.filter((item) => item?.toString() === parsedResult.data?.toString() || item?.value?.toString() === parsedResult.data?.toString())
                if (res?.[0]) {
                finalValue = !(res[0] instanceof Object && res[0].value) ? res[0] : res[0].value;
                  emit('change', finalValue);
                  Toast.success('语音输入成功');

                  isSuccess = true;
                } else {
                  Toast.fail('AI未能识别有效的选项');
                  errorInfo = 'Invalid option';
                }
                isSuccess = true;
              } else if (field.value.componentProps.multiple && Array.isArray(parsedResult.data)) {
                finalValue = [];
                parsedResult.data.forEach((item) => {
                  const res = dataSource.value.filter((option) => item?.toString() === option?.toString() || option?.value?.toString() === item?.toString())
                  if (res?.[0]) {
                    finalValue.push(!(res[0] instanceof Object && res[0].value) ? res[0] : res[0].value);
                  }
                })
                if (finalValue.length) {
                  emit('change', finalValue);
                Toast.success('语音输入成功');
                isSuccess = true;
                } else {
                  Toast.fail('AI未能识别有效的选项');
                  errorInfo = 'Invalid option';
                }
                
              } else {
                Toast.fail('AI未能识别有效的选项');
                errorInfo = 'Invalid data format';
              }
              
            } else {
              Toast.fail('AI未能识别有效的选项');
              errorInfo = 'No data in result';
            }
          } else {
            Toast.fail('AI处理失败');
            errorInfo = 'No result from API';
          }
        } catch (error) {
          console.error('[Picker] 语音输入处理失败:', error);
          Toast.fail('语音输入处理失败，请重试');
          errorInfo = error.message || error.toString();
        } finally {
          const duration = Date.now() - startTime;
          
          // 上报 aegis 日志（无论成功或失败）- 包含完整的用户输入和最终结果
          try {
            const aegis = store.state.user?.aegis;
            if (aegis) {
              aegis.infoAll({
                msg: JSON.stringify({
                  type: 'picker_voice_input_complete',
                  component: 'Picker',
                  sessionId: sessionId,
                  fieldName: field.value.path?.toString() || '',
                  fieldTitle: field.value.title || '',
                  // 用户输入
                  userInput: {
                    query: query,
                    queryLength: query.length,
                  },
                  // AI 处理结果
                  aiResult: apiResult ? {
                    success: isSuccess,
                    rawResponse: apiResult.data?.data?.result || null,
                    parsedData: finalValue,
                    error: errorInfo,
                  } : {
                    success: false,
                    error: errorInfo || 'No API response',
                  },
                  // 最终填入的值
                  finalValue: finalValue,
                  finalValueType: Array.isArray(finalValue) ? 'array' : typeof finalValue,
                  // 上下文信息
                  context: {
                    optionsCount: dataSource.value?.length || 0,
                    isMultiple: !!field.value.componentProps.multiple,
                    currentValue: field.value.value,
                  },
                  // 性能指标
                  performance: {
                    duration: duration,
                    timestamp: new Date().toISOString(),
                  },
                }),
                ext1: 'picker-voice-input',
                trace: isSuccess ? 'picker-voice-success' : 'picker-voice-fail',
              });
            }
          } catch (e) {
            console.error('[Picker] Aegis 上报失败:', e);
          }
          
          isProcessingVoice.value = false;
          voiceRecognitionText.value = ''; // 清空识别文本
        }
      };
      
      watch(
        () => attrs.value,
        (newVal) =>
          (selected.value =
            newVal && field.value.componentProps.multiple
              ? dataSource.value.filter(({ value }) => newVal.includes(value))
              : newVal || []),
        { deep: true }
      );
      const handleSearchNations = (val) => {
        searchValue.value = val;
        filtered.value = dataSource.value.filter(
          (item) =>
            item.label?.toLowerCase()?.includes(searchValue.value?.toLowerCase()) ||
            item.value?.toLowerCase()?.includes(searchValue.value?.toLowerCase())
        );
      };      
      return () =>
        h(
          'div',
          {},
          {
            default: () => [
              h(
                formilyFormItem,
                {
                  attrs: {
                    isLink: field.value.pattern === 'editable' && !isProcessingVoice.value,
                    value:
                      dataSource.value
                        .filter(({ value }) =>
                          Array.isArray(attrs.value)
                            ? attrs.value.includes(value)
                            : value === attrs.value
                        )
                        ?.map(({ label }) => label)
                        ?.toString() || field.value.value || '',
                    readonly: true,
                    
                    ...formItemProps,
                    clearable: field.value.componentProps.clearable,
                    disabled: isProcessingVoice.value,
                    loading: isProcessingVoice.value,
                    placeholder: voiceRecognitionText.value || field.value.componentProps.placeholder || ('请选择' + field.value.title),
                  },
                  on: {
                    click: () => {
                      if (field.value.pattern !== 'editable' || isProcessingVoice.value) return;
                      show.value = true;
                    },
                    ...fieldListeners,
                  },
                },
                {
                  ...slots,
                  default: () => [
                    dataSource.value
                        .filter(({ value }) =>
                          Array.isArray(attrs.value)
                            ? attrs.value.includes(value)
                            : value === attrs.value
                        )
                        ?.map(({ label }) => label)
                        ?.toString() || field.value.value || ''
                  ],
                  // 添加extra slot用于语音输入
                  'right-icon': () => {
                    const extraContent = [];
                    
                    // 保留原有的extra slot内容
                    if (slots.extra) {
                      const originalExtra = slots.extra();
                      if (Array.isArray(originalExtra)) {
                        extraContent.push(...originalExtra);
                      } else if (originalExtra) {
                        extraContent.push(originalExtra);
                      }
                    }
                    
                    // 添加语音输入按钮
                    if (
                      voiceVisible &&
                      field.value.pattern === 'editable' &&
                      field.value.componentProps.enableVoiceInput !== false
                    ) {
                      extraContent.push(
                        h(VoiceInput, {
                          props: {
                            value: '',
                            componentType: 'Picker',
                            fieldName: field.value.path?.toString() || '',
                            fieldTitle: field.value.title || '',
                            isProcessing: isProcessingVoice.value,
                          },
                          on: {
                            // 监听实时输入变化
                            input: (val) => {
                              voiceRecognitionText.value = val ? `正在识别: ${val}` : '';
                            },
                            // start: (val) => {
                            //   emit('change', undefined);
                            // },
                            // 监听语音输入结束
                            stopVoiceInput: (val) => {
                              if (val && val.trim()) {
                                // 防抖检查
                                const now = Date.now();
                                if (now - lastVoiceInputTime < DEBOUNCE_DELAY) {
                                  // Toast('操作过于频繁，请稍后再试');
                                  voiceRecognitionText.value = '';
                                  return;
                                }
                                lastVoiceInputTime = now;
                                console.log(val, 'val')
                                handleVoiceInput(val);
                              } else {
                                // 没有识别到内容，清空显示
                                voiceRecognitionText.value = '';
                              }
                            },
                          },
                        }, {
                          default: () => [],
                        })
                      );
                    }
                    
                    return extraContent;
                  },
                }
              ),
              h(
                VanPopup,
                {
                  attrs: {
                    value: show.value,
                    round: true,
                    position: 'bottom',
                    ...popupProps,
                    'get-container': 'body',
                  },
                  on: {
                    input: (val) => {
                      show.value = val;
                    },
                    ...popupListeners,
                  },
                },
                {
                  default: () => [
                    field.value.componentProps.allowCreate && !dataSource.value.length
                      ? h(
                          VanSearch,
                          {
                            attrs: {
                              value: inputValue.value,
                              shape: 'round',
                              placeholder: '暂无数据，支持手动输入后回车确认',
                              clearable: true,
                            },
                            on: {
                              input(val) {
                                inputValue.value = val;
                              },
                              search(val) {
                                emit('change', inputValue.value);
                                show.value = false;
                                inputValue.value = '';
                              },
                              clear() {
                                inputValue.value = '';
                              },
                            },
                          },
                          {
                            default: () => [inputValue.value],
                          }
                        )
                      : null,
                    field.value.componentProps.filterable && dataSource.value.length
                      ? h(
                          VanSearch,
                          {
                            attrs: {
                              value: searchValue.value,
                              shape: 'round',
                              placeholder: '在这里搜索',
                              leftIcon: 'search',
                              clearable: true,
                            },
                            on: {
                              input(val) {
                                handleSearchNations(val);
                              },
                              search(val) {
                                handleSearchNations(val);
                              },
                              clear() {
                                searchValue.value = '';
                              },
                            },
                            scopedSlots: {
                              // 在搜索框右侧添加 OCR 按钮（根据enableImageUpload控制显示）
                              'right-icon': () => {
                                try {
                                  const _$context = field.value.form?.values?.$context || {};
                                  const _explicitProp = field.value.componentProps.enableImageUpload;
                                  // 当 enableImageUpload 被显式设置为 false 时，直接关闭OCR，优先级最高
                                  if (_explicitProp === false) {
                                    return null;
                                  }
                                let _photoServiceMatch = false;
                                let _photoKeyMatch = false;
                                try {
                                  const photoServiceList = JSON.parse(store.getters.getConfigItem('photoServiceList'));
                                  if (Array.isArray(photoServiceList) && photoServiceList.includes(_$context.service_name)) {
                                    _photoServiceMatch = true;

                                  }
                                } catch (e) {}
                                try {
                                  const photoKeyList = JSON.parse(store.getters.getConfigItem('photoKeyList'));
                                  if (Array.isArray(photoKeyList)) {
                                    if (photoKeyList.length === 0 || photoKeyList.includes(_$context.ProcessDefinitionKey)) {
                                      _photoKeyMatch = true;
                                    }
                                  }
                                } catch (e) {}
                                let _photoFieldBlocked = false;
                                try {
                                  const photoFieldBlacklist = JSON.parse(store.getters.getConfigItem('photoFieldBlacklist'));
                                  const _fieldPath = field.value.path?.toString() || '';
                                  if (Array.isArray(photoFieldBlacklist) && photoFieldBlacklist.includes(_$context.ProcessDefinitionKey)) {
                                    _photoFieldBlocked = true;
                                  }
                                } catch (e) {}
                                // 仅在启用图片上传时显示OCR按钮
                                if (!(!_photoFieldBlocked && (_explicitProp || _photoServiceMatch || _photoKeyMatch))) {
                                  return null;
                                }
                                } catch (e) {
                                  return null;
                                }
                                
                                
                                return h(ImageUploadInput, {
                                  props: {
                                    value: searchValue.value,
                                    fieldName: field.value.path?.toString() || '',
                                    fieldTitle: '图片识别' || '',
                                    action: '/relay/cosfile/index',
                                    newChooseImage: false,
                                    ocrCallback: null,
                                    extraPrompt: '',
                                    showToolbarStyle: true, // 使用工具栏样式
                                    processDefinitionKey: field.value.form?.values?.$context?.ProcessDefinitionKey || '',
                                  },
                                  on: {
                                    'ocr-text-selected': (text) => {
                                      // OCR识别的文字自动填入搜索框并触发搜索
                                      searchValue.value = text;
                                      handleSearchNations(text);
                                    },
                                  },
                                }, {
                                  default: () => [],
                                });
                              },
                            },
                          },
                          {
                            default: () => [searchValue.value],
                          }
                        )
                      : null,
                    h(
                      VanPicker,
                      {
                        attrs: {
                          showToolbar: true,
                          title: field.value.title || '',
                          ...pickerProps,
                          'value-key': 'label',
                          defaultIndex:
                            dataSource.value.findIndex(
                              (item) => item.value === field.value.value
                            ) || 0,
                          columns: showFiltered.value ? filtered.value : dataSource.value,
                          ...field.value.componentProps,
                        },
                        on: {
                          cancel: () => {
                            show.value = false;
                            searchValue.value = '';
                          },
                          confirm: (val) => {
                            console.log(val);
                            // 单选时，如果选中的选项被禁用，阻止选择
                            if (!field.value.componentProps.multiple) {
                              const selectedOption = dataSource.value.find(
                                (item) => item.value === val.value
                              );
                              if (selectedOption?.disabled) {
                                Toast('该选项不可选');
                                return;
                              }
                            }
                            emit(
                              'change',
                              field.value.componentProps.multiple
                                ? selected.value.map(({ value }) => value)
                                : val.value
                            );
                            show.value = false;
                            searchValue.value = '';
                          },
                          ...pickerListeners,
                        },
                      },
                      {
                        option: (option) => {
                          if (!field.value.componentProps.multiple) return;
                          return [
                            h(
                              VanCheckboxGroup,
                              {
                                attrs: {
                                  value: selected.value.map(({ value }) => value),
                                  showToolbar: true,
                                  ...pickerProps,
                                  ...field.value.componentProps,
                                  // name: option,
                                },
                                on: {
                                  input(val) {
                                    selected.value = dataSource.value.filter(({ value }) =>
                                      val.includes(value)
                                    );
                                  },
                                },
                              },
                              {
                                default: () => [
                                  h(
                                    VanCheckbox,
                                    {
                                      attrs: {
                                        showToolbar: true,
                                        ...pickerProps,
                                        ...field.value.componentProps,
                                        name: option.value,
                                        disabled: option.disabled,
                                      },
                                    },
                                    {
                                      default: () => [option && option.label],
                                    }
                                  ),
                                ],
                              }
                            ),
                          ];
                        },
                      }
                    ),
                  ],
                }
              ),
            ],
          }
        );
    },
  })
);

export const Picker = connect(
  BasePicker,
  mapProps({ dataSource: 'options', readOnly: 'readonly' }),
  mapReadPretty(PickerPreviewText)
);

export default Picker;
